import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from 'store';

import { registrationCreated } from '../actions';
import { setCountry } from '../country/countrySlice';

import { Basket, BasketItem } from './basketAPI';

export interface BasketState {
  exams: BasketItem[];
  priceValidTo?: string;
  isLastSessionStage: boolean;
}

const initialState: BasketState = {
  exams: [],
  isLastSessionStage: false
};

export const basketSelectorSlice = createSlice({
  name: 'basket',
  initialState,
  reducers: {
    removeItem: (state, action: PayloadAction<number>) => {
      state.exams = state.exams.filter((exam) => exam.examOptionId !== action.payload);
    },
    setBasketItems: (state, action: PayloadAction<Basket>) => {
      state.exams = action.payload.basketItems;
      state.priceValidTo = action.payload.priceValidTo;
      state.isLastSessionStage = action.payload.isLastSessionStage;
    },
    updateBasketItems: (state, action: PayloadAction<BasketItem[]>) => {
      state.exams = state.exams.map((exam) => {
        const updatedExam = action.payload.find((x) => x.examOptionId === exam.examOptionId);
        return { ...exam, ...updatedExam };
      });
    },
  },
  extraReducers: (builder) => {
    //TODO[GP - future fix]:
    //  "valid" property can't be cleared, because it is used in many other places.
    //  We should change it to fetch this property from api instead cache it on app side,
    //  because this solution does not guarantee that the "valid" property will always be correct.
    builder.addCase(registrationCreated, (state) => {
      return { ...initialState, priceValidTo: state.priceValidTo };
    });
    builder.addCase(setCountry, (state) => {
      return { ...initialState, priceValidTo: state.priceValidTo };
    });
  },
});

export const { removeItem, setBasketItems, updateBasketItems } = basketSelectorSlice.actions;

export const selectBasketExams = (state: RootState): BasketItem[] => state.basket.exams;

export const selectBasketValidDate = (state: RootState) => ({
  priceValidTo: state.basket.priceValidTo,
  isLastSessionStage: state.basket.isLastSessionStage
});

export const selectBasketExamsNumber = (state: RootState): number => state.basket.exams.length;

export default basketSelectorSlice.reducer;
